import { useApiGetStores } from './useApiGetStores'

export const useApiGetStore = (storeId: number) => {
  const storesResponse = useApiGetStores({ enabled: !!storeId })
  return {
    ...storesResponse,
    data: storesResponse?.data?.find(store => store.id === storeId) ?? null
  }
}
